import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 73.9 112.4" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M73.9 56.2l-56.3 56.2L0 94.7l38.5-38.5L0 17.7 17.6 0z" /></svg>);